import { render } from "./IconsPage.vue?vue&type=template&id=4b6d4cbc"
import script from "./IconsPage.vue?vue&type=script&lang=js"
export * from "./IconsPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__